/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import BottomSection from "../shared-ui/bottom-section";
import SingleWordComponent from "./survey-questions-type/single-word";
import SingleSelectionComponent from "./survey-questions-type/single-selection";
import GreetingComponent from "./greeting";
import NameComponent from "./name";
import { getContentFromContentStack } from "../../core/contentStack";
import HeightAndWeightComponent from "../personalized/survey-questions-type/height-and-weight";
import ShortAnswerComponent from "./survey-questions-type/short-answer";
import MultipleSelectionComponent from "./survey-questions-type/multiple-selection";
import MultipleDropdownComponent from "./survey-questions-type/multiple-dropdown";
import SearchAndSelectComponent from "./survey-questions-type/search-select";
import RankingSelectionComponent from "./survey-questions-type/ranking-selection";
import MultipleSelectionWithNoneComponent from "./survey-questions-type/multiple-selection-none";
import ShortAnswerWithNoneComponent from "./survey-questions-type/short-answer-none";
import { getNeedStatesIds } from "../../utils/needStateQuestions";
import { filterRecoResponseData } from "../../utils/userResponse";
import { getUpdatedOptionsList } from "../../utils/optionsList";
import _ from "lodash";
import ConnectionMoment from "./connection-moment";
import { validateOktaSession } from "../../utils/validateOktaSession";
import {
  compareGuestExpiryTime,
  setGuestSaveResultTime,
  setGuestExpiryTime,
} from "../../utils/handleExpiryTime";
import { clearSession } from "../../utils/clearSession";
import { withOktaAuth } from "@okta/okta-react";
import { handleGuestExpiryPopup } from "../../utils/handlePopups";
import SaveResultsPopup from "../shared-ui/popup/save-results";
import ErrorScreen from "../shared-ui/errors/error-screen";
import { utag, withUtag } from "../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";
import ShortRankingSelectionComponent from "./survey-questions-type/short-ranking-selection";
// Interface for PersonalDetailsComponent State
interface PersonalDetailsComponentState {
  count: any;
  userAge: number;
  inValidAge: boolean;
  errorMsg: string;
  isEmptyAge: boolean;
  isEmptySelected: boolean;
  seletedButton: boolean;
  userName: any;
  inputName?: any;
  isError: boolean;
  answerType: string;
  contentTypeId: string;
  result: any;
  previousContentTypeId: string;
  whyQuestionList: string[];
  foundationalArray: any[];
  initialFoundationalArray: any[];
  optionsList: any[];
  enableBackAndContiune: boolean;
  totalCount: number;
  endSurvey: boolean;
  isSessionExpired: boolean;
  isPopupOpen: boolean;
  isRecoError: boolean;
  locationState: string;
}

/**
 * Foundation Questions component
 *
 * @namespace PersonalDetailsComponent
 */
class PersonalDetailsComponent extends React.Component<
  any,
  PersonalDetailsComponentState
> {
  handleContinue: any;
  myRef: any;
  constructor(props: any) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      count: sessionStorage.getItem("foundationalPageCount") || 0,
      userAge: 0,
      inValidAge: false,
      errorMsg: "",
      isEmptyAge: false,
      isEmptySelected: false,
      seletedButton: false,
      userName: "",
      inputName: "",
      isError: false,
      answerType: "single-slection",
      contentTypeId: "ms_gender",
      previousContentTypeId: "",
      result: [],
      whyQuestionList: [],
      foundationalArray: [],
      initialFoundationalArray: [],
      optionsList: [],
      enableBackAndContiune: true,
      totalCount: 0,
      endSurvey: false,
      isSessionExpired: false,
      isPopupOpen: false,
      isRecoError: false,
      locationState: "",
    };
  }

  async componentDidMount() {
    //update to analytics
    // let authObj = getUtagAuthObject();
    // let sessionObj = getUtagSessionObject();
    // let needStatesObj = getUtagNeedStates();

    // let obj = {
    //   page_name: "Foundational screen",
    //   event_name: "Foundational loading",
    // };
    // let updatedObj = _.merge(
    //   localStorage.getItem("user-info") ? authObj : {},
    //   localStorage.getObj("reco-result") ? needStatesObj : {},
    //   sessionObj,
    //   obj
    // );
    // withUtag().then((utag) => utag.view(updatedObj));
    //getContentFormComponenet function is called here
    this.getContentForComponent("ms_foundational_ques");

    //handles guest expiryTime case
    handleGuestExpiryPopup(this.props);
  }

  componentDidUpdate() {
    this.myRef.current.scrollTo(0, 0);
    if (
      localStorage.getItem("guestExpiryTime") &&
      compareGuestExpiryTime() < 0
    ) {
      clearSession(this.props);
    }

    if (
      !_.isEmpty(this.state.locationState) &&
      this.state.locationState !== this.props.history.location?.key
    ) {
      this.setState(
        {
          locationState: this.props.history.location?.key,
        },
        () => {
          if (this.props.history.action === "POP") {
            this.goBack();
          }
        }
      );
    }
  }

  componentWillReceiveProps(props: any) {
    validateOktaSession(this.props.oktaAuth);
    //enables login session expiry popup
    if (
      sessionStorage.getItem("login-session-expired") &&
      !(localStorage?.getItem("okta-token-storage") !== "{}")
    ) {
      this.setState({
        isSessionExpired: true,
        isPopupOpen: true,
      });
    }

    //getContentFormComponenet function is called here
    if (props && props.i18n.language) {
      const { foundationalArray } = this.state;
      this.getContentForComponent(foundationalArray[this.state.count]);
    }
  }

  /**
   * This method is used to handle content from content stack
   * @param {string} contentTypeId
   *
   */

  getContentForComponent = (contentTypeId: string) => {
    getContentFromContentStack(contentTypeId)
      .then((response) => {
        if (response && response.error_message) {
          this.setState({
            errorMsg: response,
          });
        } else {
          this.setState(
            {
              result: response && response[0],
            },
            () => {
              if (contentTypeId === "ms_foundational_ques") {
                this.setFoundationalArray();
              }
              if (
                (this.state?.result &&
                  this.state?.result?.[0] &&
                  this.state?.result[0]?.question_type) ||
                this.state?.result[0]?.cm_type === "cm_dyk"
              ) {
                this.setState({
                  enableBackAndContiune: true,
                });
              } else {
                this.setState({
                  enableBackAndContiune: false,
                });
              }
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This method is used to call child handleError method
   *
   */

  handleChildContinue = (value: any) => {
    this.handleContinue = value;
  };

  /**
   * This method is used to add or update the data
   *
   */

  upsert(array: any, item: any) {
    const i = array.findIndex((_item: any) => _item.id === item.id);
    if (i > -1) {
      array[i] = item;
    } else {
      array.push(item);
    }
    return array;
  }

  /**
   * This method is used for handling successful continue
   *
   */
  handleSuccessfulContinue = async (
    selectedNeedStates?: any,
    position?: number,
    dependentContentType?: any,
    isValueFound?: boolean,
    dropDownDependency?: boolean,
    valuesToAdd?: any,
    valuesToRemove?: any
  ) => {
    const { foundationalArray, initialFoundationalArray } = this.state;
    if (selectedNeedStates && position) {
      let finalData: any = [];
      const needStates = getNeedStatesIds(selectedNeedStates);
      needStates.then((data) => {
        finalData = [...initialFoundationalArray];
        finalData.splice(position - 1, 0, ...data);
        const convertIntoNumber = parseInt(this.state.count);
        sessionStorage.setItem("allQuestions", JSON.stringify(finalData));
        if (dropDownDependency) {
          this.dropdownCmDependency(
            finalData,
            dropDownDependency,
            valuesToAdd,
            valuesToRemove
          );
        } else {
          this.setState(
            {
              foundationalArray: finalData,
              totalCount: finalData.length,
              count: convertIntoNumber + 1,
            },
            () => {
              this.props.history.push(
                `/foundational?question=${
                  this.state.foundationalArray[this.state.count]
                }`,
                {
                  totalCount: this.state.totalCount,
                  progressCount: this.state.count,
                }
              );
            }
          );
        }
      });
    } else if (dependentContentType) {
      const dependentContentTypes = _.cloneDeep(dependentContentType);

      if (isValueFound) {
        let data = [...foundationalArray];
        let initialData = [...initialFoundationalArray];

        //remove the value from foundational array and add/update it's position
        for (let index = 0; index < dependentContentTypes.length; index++) {
          let indexOfItem = data?.indexOf(dependentContentTypes[index]);
          let indexInitial = initialData?.indexOf(dependentContentTypes[index]);
          let arrayStorage = sessionStorage.getItem("dependencyArray");
          let arrayStorageInitial = sessionStorage.getItem(
            "dependencyArrayInitial"
          );

          if (indexOfItem > -1) {
            if (arrayStorage === null) {
              let newArray: any = [];
              const Obj = {
                id: dependentContentTypes[index],
                position: indexOfItem,
              };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any =
                sessionStorage.getItem("dependencyArray");
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = {
                id: dependentContentTypes[index],
                position: indexOfItem,
              };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            }

            // if(data.includes(dependentContentTypes[index]))
            // {

            // }
            // data.splice(indexOfItem, 1);
          }

          if (indexInitial > -1) {
            if (arrayStorageInitial === null) {
              let newArray: any = [];
              const Obj = {
                id: dependentContentTypes[index],
                position: indexInitial,
              };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any = sessionStorage.getItem(
                "dependencyArrayInitial"
              );
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = {
                id: dependentContentTypes[index],
                position: indexInitial,
              };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            }
          }
        }

        for (let index = 0; index < dependentContentTypes.length; index++) {
          let indexNew = data.indexOf(dependentContentTypes[index]);

          if (indexNew > -1) {
            data.splice(indexNew, 1);
          }
        }

        for (let index = 0; index < dependentContentTypes.length; index++) {
          let indexNew = data.indexOf(dependentContentTypes[index]);

          if (indexNew > -1) {
            initialData.splice(indexNew, 1);
          }
        }

        sessionStorage.setItem(
          "updatedInitialArray",
          JSON.stringify(initialData)
        );
        sessionStorage.setItem("allQuestions", JSON.stringify(data));
        const convertIntoNumber = parseInt(this.state.count);
        this.setState(
          {
            foundationalArray: data,
            initialFoundationalArray: initialData,
            totalCount: data.length,
            count: convertIntoNumber + 1,
          },
          () => {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                totalCount: this.state.totalCount,
                progressCount: this.state.count,
              }
            );
          }
        );
      } else {
        //get the position and insert the data if not present in foundational array
        const data: any = [...foundationalArray];
        const initialData: any = [...initialFoundationalArray];
        for (let index = 0; index < dependentContentTypes.length; index++) {
          const isObjectPresent = data?.find(
            (item: any) => item === dependentContentTypes[index]
          );
          const isInitialObjectPresent = initialData?.find(
            (item: any) => item === dependentContentTypes[index]
          );
          if (!isObjectPresent) {
            let arrayStorage: any = sessionStorage.getItem("dependencyArray");
            let convertedArray = JSON.parse(arrayStorage);
            const found = convertedArray?.find(
              (element: any) => element?.id === dependentContentTypes[index]
            );
            if (found?.position > -1) {
              data.splice(found?.position, 0, dependentContentTypes[index]);
            }
          }

          if (!isInitialObjectPresent) {
            let arrayStorageInitial: any = sessionStorage.getItem(
              "dependencyArrayInitial"
            );
            let convertedArray = JSON.parse(arrayStorageInitial);
            const found = convertedArray?.find(
              (element: any) => element?.id === dependentContentTypes[index]
            );
            if (found?.position > -1) {
              initialData.splice(
                found?.position,
                0,
                dependentContentTypes[index]
              );
            }
          }
        }

        sessionStorage.setItem(
          "updatedInitialArray",
          JSON.stringify(initialData)
        );
        sessionStorage.setItem("allQuestions", JSON.stringify(data));
        const convertIntoNumber = parseInt(this.state.count);
        this.setState(
          {
            foundationalArray: data,
            initialFoundationalArray: initialData,
            totalCount: data.length,
            count: convertIntoNumber + 1,
          },
          () => {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                totalCount: this.state.totalCount,
                progressCount: this.state.count,
              }
            );
          }
        );
      }
    } else if (dropDownDependency) {
      const data = [...foundationalArray];
      const initialData = [...initialFoundationalArray];
      if (valuesToAdd.length > 0) {
        // let data = [...foundationalArray];
        //get the position of values and insert them  if not present in foundational array
        for (let index = 0; index < valuesToAdd.length; index++) {
          const element = valuesToAdd[index];
          const isObjectPresent = data?.find((item: any) => item === element);
          if (!isObjectPresent) {
            let arrayStorage: any = sessionStorage.getItem("dependencyArray");
            let convertedArray = JSON.parse(arrayStorage);
            const found = convertedArray?.find(
              (item: any) => item?.id === element
            );
            if (found?.position > -1) {
              data.splice(found?.position, 0, element);
            }
          }
          const isInitialObjectPresent = initialData?.find(
            (item: any) => item === element
          );
          if (!isInitialObjectPresent) {
            let arrayStorageInitial: any = sessionStorage.getItem(
              "dependencyArrayInitial"
            );
            let convertedArray = JSON.parse(arrayStorageInitial);
            const found = convertedArray?.find(
              (item: any) => item?.id === element
            );
            if (found?.position > -1) {
              initialData.splice(found?.position, 0, element);
            }
          }
        }
        sessionStorage.setItem(
          "updatedInitialArray",
          JSON.stringify(initialData)
        );
        sessionStorage.setItem("allQuestions", JSON.stringify(data));
        const convertIntoNumber = parseInt(this.state.count);
        this.setState(
          {
            foundationalArray: data,
            initialFoundationalArray: initialData,
            totalCount: data.length,
            count: convertIntoNumber + 1,
          },
          () => {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                totalCount: this.state.totalCount,
                progressCount: this.state.count,
              }
            );
          }
        );
      }
      if (valuesToRemove.length > 0) {
        //remove the values from foundational array and add/update their position
        let valuesToRemoveNew: any = [];
        for (let i = 0; i < valuesToRemove.length; i++) {
          const element = valuesToRemove[i];
          let indexOfItem = data?.indexOf(element);
          if (indexOfItem > this.state.count) {
            valuesToRemoveNew.push(valuesToRemove[i]);
          }
        }

        for (let i = 0; i < valuesToRemoveNew.length; i++) {
          const element = valuesToRemoveNew[i];
          let indexOfItem = data?.indexOf(element);
          let indexInitial = initialData?.indexOf(element);
          let arrayStorage = sessionStorage.getItem("dependencyArray");
          let arrayStorageInitial = sessionStorage.getItem(
            "dependencyArrayInitial"
          );
          if (indexOfItem > -1) {
            if (arrayStorage === null) {
              let newArray: any = [];
              const Obj = { id: element, position: indexOfItem };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any =
                sessionStorage.getItem("dependencyArray");
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = { id: element, position: indexOfItem };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            }
            // if (indexOfItem > -1) {
            //   data.splice(indexOfItem, 1);
            // }
          }
          if (indexInitial > -1) {
            if (arrayStorageInitial === null) {
              let newArray: any = [];
              const Obj = { id: element, position: indexInitial };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any = sessionStorage.getItem(
                "dependencyArrayInitial"
              );
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = { id: element, position: indexInitial };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            }
            // if (indexInitial > -1) {
            //   initialData.splice(indexInitial, 1);
            // }
          }
        }

        for (let index = 0; index < valuesToRemoveNew.length; index++) {
          let indexNew = data.indexOf(valuesToRemoveNew[index]);

          if (indexNew > -1) {
            data.splice(indexNew, 1);
          }
        }

        for (let index = 0; index < valuesToRemoveNew.length; index++) {
          let indexNew = data.indexOf(valuesToRemoveNew[index]);

          if (indexNew > -1) {
            initialData.splice(indexNew, 1);
          }
        }

        sessionStorage.setItem(
          "updatedInitialArray",
          JSON.stringify(initialData)
        );
        sessionStorage.setItem("allQuestions", JSON.stringify(data));
        const convertIntoNumber = parseInt(this.state.count);
        this.setState(
          {
            foundationalArray: data,
            initialFoundationalArray: initialData,
            totalCount: data.length,
            count: convertIntoNumber + 1,
          },
          () => {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                totalCount: this.state.totalCount,
                progressCount: this.state.count,
              }
            );
          }
        );
      }
    } else {
      const convertIntoNumber = parseInt(this.state.count);

      if (convertIntoNumber === foundationalArray.length - 2) {
        // setTimeout(() => {
        //   console.log("API call");
        //   filterRecoResponseData(foundationalList);
        //   setGuestSaveResultTime();
        // }, 300);
        const foundationalList: Array<String> = this.state?.foundationalArray;

        // setTimeout(() => {
        await filterRecoResponseData(foundationalList).then(
          async (resp: any) => {
            if (resp.isError) {
              this.setState({
                isRecoError: true,
              });
            } else {
              // this.setState({
              //   isRecoError: false
              // })
              // setTimeout(() => {
              this.setState(
                {
                  count: convertIntoNumber + 1,
                  endSurvey: true,
                  isRecoError: false,
                },
                () => {
                  this.props.history.push(
                    `/foundational?question=${
                      this.state.foundationalArray[this.state.count]
                    }`,
                    {
                      totalCount: this.state.totalCount,
                      progressCount: this.state.count,
                    }
                  );
                  this.getContentForComponent(
                    foundationalArray[this.state.count]
                  );
                }
              );
              // }, 300); //6000
            }
          }
        );
        // }, 300);

        // setTimeout(() => {
        //   this.setState(
        //     {
        //       count: convertIntoNumber + 1,
        //       endSurvey: true,
        //     },
        //     () => {
        //       this.props.history.replace("/foundational", {
        //         totalCount: this.state.totalCount,
        //         progressCount: this.state.count,
        //       });
        //       this.getContentForComponent(foundationalArray[this.state.count]);
        //     }
        //   );
        // }, 500); //6000
      }
      // else if (convertIntoNumber === foundationalArray.length - 1) {
      //   localStorage.setItem("isAssessmentDone", "true");
      //   setGuestSaveResultTime();
      //   this.props.history.push("/results");
      // }
      else {
        // if (convertIntoNumber < foundationalArray?.length) {
        this.setState(
          {
            count: convertIntoNumber + 1,
          },
          () => {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                totalCount: this.state.totalCount,
                progressCount: this.state.count,
              }
            );
            this.getContentForComponent(foundationalArray[this.state.count]);
          }
        );
        // }
      }
    }

    // if (this.state?.foundationalArray?.length === this.state.count) {
    //   console.log("filter response is called");
    //   const foundationalList: Array<String> = this.state?.foundationalArray;
    //   setTimeout(() => {
    //     filterRecoResponseData(foundationalList);
    //   }, 300);
    // }
  };
  /**
   *
   */

  dropdownCmDependency = (
    finalData?: any,
    dropDownDependency?: boolean,
    valuesToAdd?: any,
    valuesToRemove?: any
  ) => {
    const { initialFoundationalArray } = this.state;
    const foundationalArray = [...finalData];
    if (dropDownDependency) {
      const data = [...foundationalArray];
      let initialData = [...initialFoundationalArray];
      if (valuesToRemove.length > 0) {
        //remove the values from foundational array and add/update their position
        for (let i = 0; i < valuesToRemove.length; i++) {
          const element = valuesToRemove[i];
          let indexOfItem = data?.indexOf(element);
          let indexInitial = initialData?.indexOf(element);
          let arrayStorage = sessionStorage.getItem("dependencyArray");
          let arrayStorageInitial = sessionStorage.getItem(
            "dependencyArrayInitial"
          );
          if (indexOfItem > -1) {
            if (arrayStorage === null) {
              let newArray: any = [];
              const Obj = { id: element, position: indexOfItem };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any =
                sessionStorage.getItem("dependencyArray");
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = { id: element, position: indexOfItem };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArray",
                JSON.stringify(returnedValue)
              );
            }
            // if (indexOfItem > -1) {
            //   data.splice(indexOfItem, 1);
            // }
          }
          if (indexInitial > -1) {
            if (arrayStorageInitial === null) {
              let newArray: any = [];
              const Obj = { id: element, position: indexInitial };
              const returnedValue = this.upsert(newArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            } else {
              let existingArray: any = sessionStorage.getItem(
                "dependencyArrayInitial"
              );
              let convertedExistingArray = JSON.parse(existingArray);
              const Obj = { id: element, position: indexInitial };
              const returnedValue = this.upsert(convertedExistingArray, Obj);
              sessionStorage.setItem(
                "dependencyArrayInitial",
                JSON.stringify(returnedValue)
              );
            }
            // if (indexInitial > -1) {
            //   initialData.splice(indexInitial, 1);
            // }
          }
        }

        for (let index = 0; index < valuesToRemove.length; index++) {
          let indexNew = data.indexOf(valuesToRemove[index]);

          if (indexNew > -1) {
            data.splice(indexNew, 1);
          }
        }

        for (let index = 0; index < valuesToRemove.length; index++) {
          let indexNew = data.indexOf(valuesToRemove[index]);

          if (indexNew > -1) {
            initialData.splice(indexNew, 1);
          }
        }

        sessionStorage.setItem(
          "updatedInitialArray",
          JSON.stringify(initialData)
        );
      }

      if (valuesToAdd.length > 0) {
        //get the position of alues and insert them  if not present in foundational array
        for (let index = 0; index < valuesToAdd.length; index++) {
          const element = valuesToAdd[index];
          const isObjectPresent = data?.find((item: any) => item === element);
          if (!isObjectPresent) {
            let arrayStorage: any = sessionStorage.getItem("dependencyArray");
            let convertedArray = JSON.parse(arrayStorage);
            const found = convertedArray?.find(
              (item: any) => item?.id === element
            );
            if (found?.position > -1) {
              data.splice(found?.position, 0, element);
            }
          }
          const isInitialObjectPresent = initialData?.find(
            (item: any) => item === element
          );
          if (!isInitialObjectPresent) {
            let arrayStorageInitial: any = sessionStorage.getItem(
              "dependencyArrayInitial"
            );
            let convertedArray = JSON.parse(arrayStorageInitial);
            const found = convertedArray?.find(
              (item: any) => item?.id === element
            );
            if (found?.position > -1) {
              initialData.splice(found?.position, 0, element);
            }
          }
        }
      }
      sessionStorage.setItem(
        "updatedInitialArray",
        JSON.stringify(initialData)
      );
      sessionStorage.setItem("allQuestions", JSON.stringify(data));
      const convertIntoNumber = parseInt(this.state.count);
      this.setState(
        {
          foundationalArray: data,
          initialFoundationalArray: initialData,
          totalCount: data.length,
          count: convertIntoNumber + 1,
        },
        () => {
          this.props.history.push(
            `/foundational?question=${
              this.state.foundationalArray[this.state.count]
            }`,
            {
              totalCount: this.state.totalCount,
              progressCount: this.state.count,
            }
          );
        }
      );
    }
  };
  /**
   * This method is used for click on back button
   *
   */
  goBack = (e?: any) => {
    let { foundationalArray } = this.state;
    const convertIntoNumber = parseInt(this.state.count);
    if (convertIntoNumber === 0) {
      this.props.history.push("/home");
    } else {
      this.setState(
        {
          count: this.state.count - 1,
        },
        () => {
          if (foundationalArray[this.state.count] === "ms_welcome_greet") {
            this.setState(
              {
                count: this.state.count - 1,
              },
              () => {
                this.props.history.push(
                  `/foundational?question=${
                    this.state.foundationalArray[this.state.count]
                  }`,
                  {
                    // totalCount: this.state.totalCount,
                    // progressCount: this.state.count,
                  }
                );
                this.getContentForComponent(
                  foundationalArray[this.state.count]
                );
              }
            );
          } else if (
            foundationalArray[this.state.count] ===
            "ms_interested_wellness_areas"
          ) {
            const { initialFoundationalArray } = this.state;
            this.setState(
              {
                // count: this.state.count - 1,
                foundationalArray: initialFoundationalArray,
              },
              () => {
                this.props.history.push(
                  `/foundational?question=${
                    this.state.foundationalArray[this.state.count]
                  }`,
                  {
                    totalCount: this.state.totalCount,
                    progressCount: this.state.count,
                  }
                );
                this.getContentForComponent(
                  foundationalArray[this.state.count]
                );
              }
            );
          } else if (
            foundationalArray[this.state.count]?.startsWith("ms_indcm") ||
            foundationalArray[this.state.count]?.startsWith("ms_depcm") ||
            foundationalArray[this.state.count]?.startsWith("ms_indcm")
          ) {
            const currentCount = this.state.count;
            let gobackPosition = 0;
            for (let i = currentCount; i > 0; i--) {
              if (
                !foundationalArray[i]?.startsWith("ms_indcm") &&
                !foundationalArray[i]?.startsWith("ms_depcm") &&
                !foundationalArray[i]?.startsWith("ms_indcm")
              ) {
                break;
              }
              gobackPosition = gobackPosition + 1;
            }
            this.setState(
              {
                count: this.state.count - gobackPosition,
              },
              () => {
                this.props.history.push(
                  `/foundational?question=${
                    this.state.foundationalArray[this.state.count]
                  }`,
                  {}
                );

                this.getContentForComponent(
                  foundationalArray[this.state.count]
                );
              }
            );
          } else {
            this.props.history.push(
              `/foundational?question=${
                this.state.foundationalArray[this.state.count]
              }`,
              {
                // totalCount: this.state.totalCount,
                // progressCount: this.state.count,
              }
            );

            this.getContentForComponent(foundationalArray[this.state.count]);
          }
        }
      );
    }
  };

  /**
   * This method is used to set the foundational array
   *
   */

  setFoundationalArray = () => {
    let { count } = this.state;
    let array = [];
    if (localStorage.getItem("surveyType") === "shortSurvey") {
      const { short_foundational_ques } =
        (this.state.result && this.state.result[0]) || {};
      const {
        basic_questions_1,
        basic_questions_2,
        basic_questions_3,
        nutrition_questions_1,
        // fitness_questions_1,
      } = short_foundational_ques || {};
      array = [
        basic_questions_1,
        // fitness_questions_1,
        basic_questions_2,
        basic_questions_3,
        nutrition_questions_1,
      ];
    } else {
      const { foundational_questions } =
        (this.state.result && this.state.result[0]) || {};
      const {
        basic_questions_1,
        basic_questions_2,
        basic_questions_3,
        nutrition_questions_1,
        // fitness_questions_1,
      } = foundational_questions || {};
      array = [
        basic_questions_1,
        // fitness_questions_1,
        basic_questions_2,
        basic_questions_3,
        nutrition_questions_1,
      ];
    }
    const arr = [];
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < (array[i] && array[i].length); j++) {
        arr.push(array[i][j]._content_type_uid);
      }
    }

    const data = sessionStorage.getItem("allQuestions");
    const dataInitial = sessionStorage.getItem("updatedInitialArray");
    this.setState(
      {
        ...this.state,
        foundationalArray: data ? JSON.parse(data) : arr,
        initialFoundationalArray: dataInitial ? JSON.parse(dataInitial) : arr,
        totalCount: data ? JSON.parse(data).length : arr.length,
      },
      () => {
        this.setState({
          locationState: `?question=${
            this.state.foundationalArray[this.state.count]
          }`,
        });
        this.props.history.push(
          `/foundational?question=${
            this.state.foundationalArray[this.state.count]
          }`,
          {
            // totalCount: this.state.totalCount,
            // progressCount: this.state.count,
          }
        );
        // const index = this.state.foundationalArray[0];
        // this.getContentForComponent(index);
        this.getContentForComponent(this.state.count);
      }
    );
  };

  tryAgain = () => {
    window.location.reload();
  };

  closePopup = () => {
    this.setState(
      {
        isPopupOpen: false,
        // showPopup: false,
      },
      () => {
        // sessionStorage.removeItem("login-session-expired")
        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          this.props.history.replace("/home");
          localStorage.setItem("logout", "true");
        }
      }
    );
  };

  render() {
    const {
      errorMsg,
      isEmptySelected,
      isError,
      result,
      foundationalArray,
      userName,
      totalCount,
      count,
      isRecoError,
    } = this.state;
    const {
      why_question_list,
      why_question_list_combo,
      palceholder_text,
      empty_error,
      enable_login,
      input_type,
      options_list,
      question_info,
      placeholder_text,
      question_label,
      question_subtitle,
      question_title,
      question_type,
      validation_errors,
      background_image,
      foreground_image,
      designation,
      enable_back,
      enable_continue,
      guest_message,
      login_message,
      primary_message,
      profile_image,
      secondary_message,
      screen_type,
      locale,
      title,
      food_combo,
      guest_info,
      guest_question_title,
      login_information,
      login_question_title,
      reco_id,
      position,
      dependent,
      restriction_options,
      cm_type,
      cm_image,
      cm_subtitle,
      cm_title,
      timer,
      dyk_title,
      need_state_cm,
      cm_dependent,
      single_option,
    } = (result && result[0]) || {};
    const question_content_type_id: any = foundationalArray
      ? foundationalArray[this.state.count]
      : "";
    sessionStorage.setItem("foundationalPageCount", this.state.count);
    let isTopAligned: any = getUpdatedOptionsList(options_list).length > 5;
    if (question_type === "search-select") {
      isTopAligned = false;
    }
    if (question_type === "dropdown") {
      isTopAligned = true;
    }
    return (
      <div className="main-area">
        <div
          className={
            isTopAligned
              ? "personal-info-container top-align"
              : "personal-info-container"
          }
          ref={this.myRef}
        >
          {/* <div className="count-wrapper">
            {/* <span className="count">{`${this.state.count} of 10`}</span> */}
          {/* </div> */}
          <>
            {/* Greeting Component Start */}

            {/* {screen_type && screen_type === "greeting" && (
              <GreetingComponent
                {...this.props}
                userName={userName}
                guest_message={guest_message}
                login_message={login_message}
                isAuthenticated={
                  this.props.authState && this.props.authState.isAuthenticated
                }
                handleSuccessfulContinue={this.handleSuccessfulContinue}
              />
            )} */}
            {/* Greeting Component Ends */}
            {this.state.isSessionExpired && (
              <SaveResultsPopup
                {...this.props}
                open={this.state.isPopupOpen}
                close={this.closePopup}
                popupTitle={this.props.t("common.welcome_back")}
                popupMessage={this.props.t(
                  "common.login_session_expiry_message"
                )}
                popupFirstButton={this.props.t("common.sign_in")}
                popupFirstButtonType="sign-in"
                // popupSecondButton="Take the Quiz"
              />
            )}

            {/* Connection Moment Component Start */}
            {!isRecoError ? (
              <>
                {cm_type && (
                  <ConnectionMoment
                    {...this.props}
                    connectionMomentType={cm_type}
                    connectionMomentImage={cm_image}
                    connectionMomentSubtitle={cm_subtitle}
                    connectionMomentTitle={
                      cm_type === "cm_dyk" ? dyk_title : cm_title
                    }
                    timer={timer}
                    needStateCm={need_state_cm}
                    dependentConnectionMoment={cm_dependent}
                    handleSuccessfulContinue={this.handleSuccessfulContinue}
                    handleChildContinue={this.handleChildContinue}
                    cmTitle={title}
                    isAuthenticated={
                      this.props.authState &&
                      this.props.authState.isAuthenticated
                    }
                    contentTypeId={question_content_type_id}
                    userName={userName}
                  />
                )}
                {/* Connection Moment Component Ends */}

                {/* Name Component Start */}
                {question_type && question_type === "single_line" && (
                  <NameComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    backgroundImage={background_image}
                    foregroundImage={foreground_image}
                    placeholderText={placeholder_text}
                    questionInfo={question_info}
                    validation_errors={validation_errors}
                    questionLabel={question_label}
                    enableLogin={enable_login}
                    errorMsg={validation_errors}
                    language={locale}
                    inputValue={(value: string) => {
                      this.setState({
                        userName: value,
                      });
                    }}
                    handleChildContinue={this.handleChildContinue}
                    handleSuccessfulContinue={this.handleSuccessfulContinue}
                    guest_info={guest_info}
                    login_information={login_information}
                    guest_question_title={guest_question_title}
                    login_question_title={login_question_title}
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                  />
                )}
                {/* Name Component Ends */}

                {/* Single Selection Component Start */}
                {question_type && question_type === "single_choice" && (
                  <SingleSelectionComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    optionsList={options_list}
                    optionName={"gender"}
                    // isSelected={(value: boolean) => this.handleSelected(value)}
                    disableAutoForward={
                      parseInt(this.state.count) >= foundationalArray.length - 2
                    }
                    isEmptySelected={isEmptySelected}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    handleChildContinue={this.handleChildContinue}
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                    dependent={dependent}
                    cmDependent={cm_dependent}
                  />
                )}
                {/* Single Selection Component Ends */}

                {/* Single Word Numeric Component Start */}
                {question_type && question_type === "numeric" && (
                  <SingleWordComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    inputType={"text"}
                    inputPlaceHolder={placeholder_text}
                    // inputValue={(evt) => this.handleInputChange(evt)}
                    // isSelected={(value: boolean) => this.handleSelected(value)}
                    question_label={question_label}
                    isError={isError}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    language={locale}
                    handleChildContinue={this.handleChildContinue}
                    handleSuccessfulContinue={this.handleSuccessfulContinue}
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                  />
                )}
                {/* Single Word Numeric Component Ends */}

                {/* Height and weight Component Start */}
                {
                  question_type && question_type === "height-weight"
                  // <HeightAndWeightComponent
                  //   {...this.props}
                  //   questionTitle={question_title}
                  //   questionSubTitle={question_subtitle}
                  //   optionsList={options_list}
                  //   errorMsg={empty_error}
                  //   whyQuestionList={why_question_list}
                  //   inputType="number"
                  //   inputPlaceHolder={placeholder_text}
                  //   // inputValue={(evt: any) => this.handleInputChange(evt)}
                  //   isError={isError}
                  //   // handleChildContinue={this.handleChildContinue}
                  //   // handleSuccessfulContinue={this.handleSuccessfulContinue}
                  // />
                }
                {/* Height and weight Component Ends */}

                {/* Multiple choice with short answer Component Start */}
                {question_type &&
                  question_type === "multiple_choice_short_answer" && (
                    <ShortAnswerComponent
                      {...this.props}
                      questionTitle={question_title}
                      questionSubTitle={question_subtitle}
                      errorMsg={validation_errors}
                      whyQuestionList={why_question_list}
                      inputType="text"
                      inputPlaceHolder={placeholder_text}
                      listOfAnswers={options_list}
                      handleChildContinue={this.handleChildContinue}
                      contentTypeId={question_content_type_id}
                      recoId={reco_id}
                      dependent={dependent}
                      cmDependent={cm_dependent}
                      handleSuccessfulContinue={(
                        selectedNeedStates?: any,
                        position?: number,
                        dependentContentType?: any,
                        isValueFound?: boolean,
                        dropDownDependency?: boolean,
                        valuesToAdd?: any,
                        valuesToRemove?: any
                      ) =>
                        this.handleSuccessfulContinue(
                          selectedNeedStates,
                          position,
                          dependentContentType,
                          isValueFound,
                          dropDownDependency,
                          valuesToAdd,
                          valuesToRemove
                        )
                      }
                    />
                  )}
                {/* Multiple choice with short answer Component Ends */}

                {/* Multiple selection Component Start */}
                {question_type && question_type === "multiple-selection" && (
                  <MultipleSelectionComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    listOfAnswers={options_list}
                    handleChildContinue={this.handleChildContinue}
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                    dependent={dependent}
                    cmDependent={cm_dependent}
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                  />
                )}
                {/* Multiple selection Component Ends */}

                {/* Multiple selection with none Component Start */}
                {question_type &&
                  question_type === "multiple-selection-with-none" && (
                    <MultipleSelectionWithNoneComponent
                      {...this.props}
                      questionTitle={question_title}
                      questionSubTitle={question_subtitle}
                      errorMsg={validation_errors}
                      whyQuestionList={why_question_list}
                      listOfAnswers={options_list}
                      handleChildContinue={this.handleChildContinue}
                      contentTypeId={question_content_type_id}
                      recoId={reco_id}
                      dependent={dependent}
                      cmDependent={cm_dependent}
                      handleSuccessfulContinue={(
                        selectedNeedStates?: any,
                        position?: number,
                        dependentContentType?: any,
                        isValueFound?: boolean,
                        dropDownDependency?: boolean,
                        valuesToAdd?: any,
                        valuesToRemove?: any
                      ) =>
                        this.handleSuccessfulContinue(
                          selectedNeedStates,
                          position,
                          dependentContentType,
                          isValueFound,
                          dropDownDependency,
                          valuesToAdd,
                          valuesToRemove
                        )
                      }
                    />
                  )}
                {/* Multiple selection with none Component Ends */}

                {/*Multiple choice with short answer and none Component Start */}
                {question_type &&
                  question_type === "multiple_choice_short_answer_none" && (
                    <ShortAnswerWithNoneComponent
                      {...this.props}
                      questionTitle={question_title}
                      questionSubTitle={question_subtitle}
                      errorMsg={validation_errors}
                      whyQuestionList={why_question_list}
                      listOfAnswers={options_list}
                      inputPlaceHolder={placeholder_text}
                      handleChildContinue={this.handleChildContinue}
                      contentTypeId={question_content_type_id}
                      recoId={reco_id}
                      dependent={dependent}
                      cmDependent={cm_dependent}
                      handleSuccessfulContinue={(
                        selectedNeedStates?: any,
                        position?: number,
                        dependentContentType?: any,
                        isValueFound?: boolean,
                        dropDownDependency?: boolean,
                        valuesToAdd?: any,
                        valuesToRemove?: any
                      ) =>
                        this.handleSuccessfulContinue(
                          selectedNeedStates,
                          position,
                          dependentContentType,
                          isValueFound,
                          dropDownDependency,
                          valuesToAdd,
                          valuesToRemove
                        )
                      }
                    />
                  )}
                {/*Multiple choice with short answer and none Component Start*/}

                {/* Multiple Dropdown Component Start */}
                {question_type && question_type === "dropdown" && (
                  <MultipleDropdownComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list_combo}
                    inputType="text"
                    isError={isError}
                    questionsList={food_combo}
                    handleChildContinue={this.handleChildContinue}
                    questionType={question_type}
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                    cmDependent={cm_dependent}
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                  />
                )}
                {/* Multiple Dropdown Component Ends */}

                {/* Search and select Component Start */}
                {question_type && question_type === "search-select" && (
                  <SearchAndSelectComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    inputType="text"
                    inputPlaceHolder={placeholder_text}
                    listOfAnswers={options_list}
                    dropDownTitle={question_label}
                    handleChildContinue={this.handleChildContinue}
                    // handleSuccessfulContinue={this.handleSuccessfulContinue}
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                    dependent={dependent}
                    cmDependent={cm_dependent}
                    restrictionOptions={restriction_options}
                    checkboxOption={single_option}
                  />
                )}
                {/* Search and select Component Ends */}

                {/* Ranking Selection Component Start */}
                {question_type && question_type === "ranking" && (
                  <RankingSelectionComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    listOfAnswers={options_list}
                    position={position}
                    handleChildContinue={this.handleChildContinue}
                    cmDependent={cm_dependent}
                    // handleSuccessfulContinue={(
                    //   selectedNeedStates: any,
                    //   position: number
                    // ) =>
                    //   this.handleSuccessfulContinue(selectedNeedStates, position)
                    // }
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                  />
                )}
                {/* Ranking Selection Component Ends */}

                {/* Short Ranking Selection Component Start */}
                {question_type && question_type === "short_survey_ranking" && (
                  <ShortRankingSelectionComponent
                    {...this.props}
                    questionTitle={question_title}
                    questionSubTitle={question_subtitle}
                    errorMsg={validation_errors}
                    whyQuestionList={why_question_list}
                    listOfAnswers={options_list}
                    position={position}
                    handleChildContinue={this.handleChildContinue}
                    cmDependent={cm_dependent}
                    // handleSuccessfulContinue={(
                    //   selectedNeedStates: any,
                    //   position: number
                    // ) =>
                    //   this.handleSuccessfulContinue(selectedNeedStates, position)
                    // }
                    handleSuccessfulContinue={(
                      selectedNeedStates?: any,
                      position?: number,
                      dependentContentType?: any,
                      isValueFound?: boolean,
                      dropDownDependency?: boolean,
                      valuesToAdd?: any,
                      valuesToRemove?: any
                    ) =>
                      this.handleSuccessfulContinue(
                        selectedNeedStates,
                        position,
                        dependentContentType,
                        isValueFound,
                        dropDownDependency,
                        valuesToAdd,
                        valuesToRemove
                      )
                    }
                    contentTypeId={question_content_type_id}
                    recoId={reco_id}
                  />
                )}
                {/* Short Ranking Selection Component Ends */}
              </>
            ) : (
              <ErrorScreen
                errorTitle={this.props.t("error.api_fail_error")}
                handleErrorBtn={() => this.tryAgain()}
                errorBtnName={this.props.t("error.error_button_try_again")}
                withBtn
              />
            )}
          </>
        </div>
        {!isRecoError ? (
          <>
            {this.state.enableBackAndContiune && foundationalArray.length > 0 && (
              <BottomSection
                {...this.props}
                btnName={
                  parseInt(this.state.count) >= foundationalArray.length - 2
                    ? this.props.t("common.bottom_section_finish")
                    : this.props.t("common.bottom_section_continue")
                }
                id={
                  parseInt(this.state.count) >= foundationalArray.length - 2
                    ? "finish"
                    : "continue"
                }
                handleButtonClick={() => this.handleContinue()}
                btnClassName={"app-btn btn-icon"}
                handleBackButton={this.goBack}
                // handleBackeButtonOnKeyPress={(e: any) => { if (e.key === "Enter") { this.goBack(e) } }}
                totalCount={totalCount}
                progressCount={parseInt(count) + 1}
              />
            )}
          </>
        ) : null}
      </div>
    );
  }
}

export default withOktaAuth(PersonalDetailsComponent);
